import { NavigateFunction } from "react-router-dom";
import bookingCycleMgr from "@services/bookingCycleMgr";
import job from "@utils/objects/job";
import { serviceAgreement } from "@src/utilities/objects";

export const delayedRedirect = async (navigate: NavigateFunction, url: string, jobId: number) => {
  // state.HomeLoading = true;
  // job.reset();
  // init global settings
  // init serviceAgreement
  serviceAgreement.reset();
  // init reset call

  if (bookingCycleMgr.getCurrentBooking() === null) {
    bookingCycleMgr.setCurrentBooking(jobId);
  }
  await job.loadIndexedDB(jobId, async () =>
    navigate("/switchboard", { replace: true, state: { jobId: jobId, delayedLoad: true } })
  );
};
